import React from 'react';
import { Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { TextInput, Select } from 'ui-library';
import './ReasonForSale.css';

const ReasonForSale = ({ datasource }) => {
    const { t } = useTranslation();
    const {
        data, control, errors, setData, reasonForSaleOptions, reasonsWithSpecifications,
    } = datasource();

    return (
        <form className="reason-for-sale-form">
            <Controller
                name="ReasonListItemId"
                control={control}
                render={({ field: { onChange, ...field } }) => (
                    <Select
                        {...field}
                        onChange={(val) => {
                            onChange(val);
                            setData('ReasonText', '');
                        }}
                        label={t('createNewCase.ReasonForSale.SelectReason')}
                        options={reasonForSaleOptions || []}
                        placeholder={t('position.pleaseSelect')}
                        data-cy="ReasonListItemId"
                        error={t(errors?.ReasonListItemId?.message || '')}
                        required
                    />
                )}
            />

            {reasonsWithSpecifications?.includes(data?.ReasonListItemId) && (
                <Controller
                    name="ReasonText"
                    control={control}
                    render={({ field }) => (
                        <TextInput
                            {...field}
                            data-cy="ReasonText"
                            label={t('createNewCase.ReasonForSale.SpecifyReason')}
                            error={t(errors?.ReasonText?.message || '')}
                        />
                    )}
                />
            )}
        </form>
    );
};

export default ReasonForSale;
